const LOGIN_URL = import.meta.env.VITE_LOGIN_URL;

export const loginRedirect = () => {
  const returnUrl = encodeURIComponent(window.location.href);
  window.location.href = `${LOGIN_URL}?returnUrl=${returnUrl}`;
};
